export const USER = {
  name: 'Akkerbouwbedrijf De Vries',
};

// Hardcoded "eigen" percelen voor demo-doeleinden.
// IDs komen uit public/data/parcels.json (brp_gewas WFS IDs).
// Bij re-fetch van data veranderen deze IDs.
// Percelen geclusterd nabij Natura 2000 + watergangen voor maximale regeldruk
export const OWN_PARCEL_IDS = [
  'brp_gewas.12d73be3-abb0-49e3-b6b7-6e455a5f4e85', // Aardappelen, poot NAK
  'brp_gewas.4497980c-f927-4c0b-8317-416557a3b00c', // Aardappelen, consumptie
  'brp_gewas.67af5c58-29fa-4fa6-bc4d-d3be47c817ba', // Mais, snij-
  'brp_gewas.2d8d4b55-0551-4b99-88e2-e844ddb2c7bd', // Tarwe, winter-
  'brp_gewas.cf1a49a4-10d8-4d4b-8f41-5c3228320882', // Mais, snij- — in Natura 2000
  'brp_gewas.4a0d9d4a-4ce8-4602-9a47-a9db4769c655', // Aardappelen, consumptie — in Natura 2000
];
